import React from "react";
import "./Header.css";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { Link, Navigate } from "react-router-dom";
import { useStateValue } from "../StateProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import A2zone from "../assets/A2zone.png";

const Header = () => {
  const navigate = useNavigate();
  const [{ basket, user }, dispatch] = useStateValue();
  const handleAuth = () => {
    if (user) {
      auth.signOut();
    }
  };
  useEffect(() => {
    console.log("The header Problem");
    console.log(user);
  }, [user]);

  const AmazonLogoUrl = A2zone;

  return (
    <div className="header">
      <Link to="/">
        <img className="header__logo" src={AmazonLogoUrl} alt="AmazoneImage" />
      </Link>
      <div className="header__search">
        <input className="header__searchInput" placeholder="" type="text" />
        <SearchIcon className="header__searchIcon" />
      </div>
      <div className="header__nav">
        <Link to={!user && "/login"}>
          <div onClick={handleAuth} className="header__option">
            <span className="header__optionLineOne">
              Hello {user ? user.email : "Guest"}
            </span>
            <span className="header__optionLineTwo">
              {user ? "Sign Out" : "Sign In"}
            </span>
          </div>
        </Link>
        <Link to="/orders">
          <div className="header__option">
            <span className="header__optionLineOne">Returns </span>
            <span className="header__optionLineTwo">& Orders </span>
          </div>
        </Link>
        <div className="header__option">
          <span className="header__optionLineOne">Your </span>
          <span className="header__optionLineTwo">Prime </span>
        </div>
        <Link to="/checkout">
          <div className="header__optionBasket">
            <ShoppingBasketIcon />
            <span classname="header__optionLineTwo header__basketCount ">
              {basket?.length}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Header;
